import React from 'react';
import { getAreaHref } from '@/lib/areaLinks';

export default function AreaPills({
  areas = [],
  variant = 'light',
  className = '',
}) {
  const styles = {
    light: 'bg-ivory text-warm-black border-brown/15 hover:bg-warm-black hover:text-cream hover:border-warm-black hover:-translate-y-0.5',
    dark: 'bg-gold-light/8 text-cream border-gold-light/25 hover:bg-gold hover:text-warm-black hover:border-gold hover:-translate-y-0.5',
  };

  const base = `px-5 py-2.5 rounded-pill text-body-s font-medium border transition-all duration-300 ${styles[variant] || styles.light}`;

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {areas.map((area, i) => {
        const href = getAreaHref(area);
        return href ? (
          <a key={i} href={href} className={base}>
            {area}
          </a>
        ) : (
          <span key={i} className={`${base} cursor-default`}>
            {area}
          </span>
        );
      })}
    </div>
  );
}